/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Field_Confirmed_By_NameInputs */

const en_cad_field_confirmed_by_name = /** @type {(inputs: Cad_Field_Confirmed_By_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const ja_cad_field_confirmed_by_name = /** @type {(inputs: Cad_Field_Confirmed_By_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`氏名`)
};

const fr_cad_field_confirmed_by_name = /** @type {(inputs: Cad_Field_Confirmed_By_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom`)
};

const de_cad_field_confirmed_by_name = /** @type {(inputs: Cad_Field_Confirmed_By_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Cad_Field_Confirmed_By_NameInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cad_field_confirmed_by_name = /** @type {((inputs?: Cad_Field_Confirmed_By_NameInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Field_Confirmed_By_NameInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cad_field_confirmed_by_name(inputs)
	if (locale === "ja") return ja_cad_field_confirmed_by_name(inputs)
	if (locale === "fr") return fr_cad_field_confirmed_by_name(inputs)
	return de_cad_field_confirmed_by_name(inputs)
});